import { SvgPropType } from './types/svgPropType';

const NewgroundsIcon = ({ width, height }: SvgPropType) => (
    <svg width={width || '32'} height={height || 32} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <text
            x="12"
            y="12"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="13"
            fontWeight="700"
            fill="black"
            fontFamily="Arial Black, Arial, Helvetica, sans-serif"
        >
            NG
        </text>
    </svg>
);

export default NewgroundsIcon;
